import ReactGA from "react-ga";

export const Event = (category, action, label) => {
  if (window.location.origin === "http://localhost:3000") return;

  ReactGA.event({ category, action, label });
};

export const PageView = page => {
  if (window.location.origin === "http://localhost:3000") return;
  else if (page) ReactGA.pageview(page);
  else ReactGA.pageview(window.location.pathname);
};

export default { Event, PageView };
